import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentOrder: null,
  loading: false,
  cooldownTime: 0,
  orderReceived: false,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrderLoading: (state, action) => {
      state.currentOrder = action.payload;
      state.loading = true;
      state.orderReceived = false;
      state.cooldownTime = action.payload?.cooldownDuration || 300;
    },
    decrementCooldown: (state) => {
      if (state.cooldownTime > 0) {
        state.cooldownTime -= 1;
      }

      if (state.cooldownTime === 0 && state.loading) {
        state.loading = false;
        state.orderReceived = true;
      }
    },
    clearOrder: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setOrderLoading, decrementCooldown, clearOrder } = orderSlice.actions;
export default orderSlice.reducer;
